import { ReactNode } from 'react';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

const styles = {
  totalBudgetLabel: {
    fontSize: fonts.sm,
    color: colors.neutral.dim,
    paddingBottom: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },
  totalBudgetAmount: {
    fontSize: fonts.lg,
    color: colors.neutral.dark,
    fontWeight: '500',
    gap: '0.5rem',
  },
};

interface Props {
  loading?: Boolean;
  label: String;
  value: String;
  icon?: ReactNode;
}

const BudgetDetailOverviewField = ({ loading, label, value, icon }: Props) => {
  return (
    <div>
      <div style={styles.totalBudgetLabel}>
        {label} {icon}
      </div>
      <div style={styles.totalBudgetAmount}>{loading ? '$0.00' : value}</div>
    </div>
  );
};

export default BudgetDetailOverviewField;
